module.exports = __webpack_public_path__ + "img/premium.00705d97.svg";